import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function ReloadSvg({ classNameProps, width, height }: PropsTypeSvg) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNameProps}
      width={width}
      height={height}
      viewBox='0 0 30 30'
      fill='none'
    >
      <path
        d='M21.5352 6.98772L17.1108 3.30074C16.2726 2.60223 15 3.19828 15 4.28938V11.6633C15 12.7544 16.2726 13.3505 17.1108 12.652L21.5352 8.96501C22.1526 8.4505 22.1526 7.50223 21.5352 6.98772Z'
        className='fill-current'
      />
      <path
        d='M24 16.5C24 18.1811 23.4722 19.8245 22.4832 21.2223C21.4943 22.6202 20.0887 23.7096 18.4442 24.353C16.7996 24.9963 14.99 25.1646 13.2442 24.8367C11.4984 24.5087 9.89471 23.6992 8.63604 22.5104C7.37737 21.3217 6.5202 19.8071 6.17293 18.1583C5.82567 16.5094 6.0039 14.8004 6.68508 13.2472C7.36627 11.694 8.51983 10.3665 9.99987 9.43251C11.4799 8.49852 13.22 8 15 8'
        className='stroke-current'
        strokeWidth='3'
        strokeLinecap='round'
      />
    </svg>
  );
}

export default ReloadSvg;
